import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.55556 6.76714H10M5.55556 9.80078H12.6667M5.55556 15.0013V17.0256C5.55556 17.4875 5.55556 17.7184 5.65265 17.837C5.73709 17.9401 5.86513 18.0001 6.00048 18C6.15611 17.9998 6.34104 17.8556 6.71089 17.5671L8.8313 15.913C9.26446 15.5751 9.48104 15.4061 9.72221 15.286C9.93618 15.1794 10.1639 15.1015 10.3993 15.0544C10.6646 15.0013 10.942 15.0013 11.4967 15.0013H13.7333C15.2268 15.0013 15.9735 15.0013 16.544 14.7179C17.0457 14.4686 17.4537 14.0708 17.7094 13.5815C18 13.0253 18 12.2972 18 10.8409V6.16042C18 4.70413 18 3.97599 17.7094 3.41977C17.4537 2.9305 17.0457 2.53271 16.544 2.28341C15.9735 2 15.2268 2 13.7333 2H6.26667C4.77319 2 4.02646 2 3.45603 2.28341C2.95426 2.53271 2.54631 2.9305 2.29065 3.41977C2 3.97599 2 4.70413 2 6.16042V11.5343C2 12.3403 2 12.7434 2.09086 13.074C2.33744 13.9714 3.05624 14.6723 3.97648 14.9127C4.31559 15.0013 4.72891 15.0013 5.55556 15.0013Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgMessage;
